import type {PerkAnalyticsParamsADto} from '@cohort/admin-schemas/perkAnalytics';
import type {PaginationFilters} from '@cohort/merchants/hooks/filters/basePageFilters';
import {useBasePageFilters} from '@cohort/merchants/hooks/filters/basePageFilters';
import type {PerkAccessStatus} from '@cohort/shared/schema/common/perks';

type PerksUsagesListFilters = {
  statuses: Array<PerkAccessStatus>;
  setStatuses: (statuses: Array<PerkAccessStatus>) => void;
  collectionIds: NonNullable<PerkAnalyticsParamsADto['collectionIds']>;
  setCollectionIds: (collectionIds: PerkAnalyticsParamsADto['collectionIds']) => void;
  sort: NonNullable<PerkAnalyticsParamsADto['orderBy']>;
  setSort: (sort: PerkAnalyticsParamsADto['orderBy']) => void;
  reset: () => void;
};

export const usePerksUsagesListFilters = (): PaginationFilters & PerksUsagesListFilters =>
  useBasePageFilters<PerksUsagesListFilters>(/^(\/test)?\/perks\/.*\/usages$/u, set => ({
    statuses: [],
    setStatuses: statuses => set({statuses}),
    collectionIds: [],
    setCollectionIds: collectionIds => set({collectionIds}),
    sort: '-lastUsageDate',
    setSort: sort => set({sort}),
    reset: () => set({statuses: [], collectionIds: [], sort: '-lastUsageDate'}),
  }));
